module.exports = __webpack_public_path__ + "img/EditorCode.3daf277a.png";